import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { getTestCasesBySuite } from '../../../../modules/testsuites';
import TableComponent from '../../../elements/TableComponent';
import { testCasestableHeader } from '../../test-case/testCaseTableHead';
import { Col, Form, Row } from 'react-bootstrap';
import MultiSelectDropdown from '../../../elements/MultiSelectDropdown';

const SelectTestCasesFromSuiteModal = ({
  suite,
  selectedTestCases,
  setSelectedTestCases,
  handleBack,
  testCycleId,
  technologyLayerOptions = [],
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState('desc');
  const [filters, setFilters] = useState({
    module: 'All',
    technologyLayer: 'All',
    labels: [],
  });
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filteredModuleOptions, setFilteredModuleOptions] = useState([]);
  const [filteredLabelOptions, setFilteredLabelOptions] = useState([]);

  useEffect(() => {
    const fetchTestCases = async () => {
      setLoading(true);
      try {
        const response = await getTestCasesBySuite(
          suite.id,
          page,
          perPage,
          true,
          testCycleId,
          filters
        );

        const formattedTestCases = response.testcases.map((testcase) => ({
          ...testcase,
          labelNames: testcase?.label_details?.map(l => l.name),
        }));

        setData(formattedTestCases);
        setTotalCount(response.total);
        setFilteredModuleOptions(response.available_modules || []);
        setFilteredLabelOptions(response.available_labels || []);
      } catch (error) {
        console.error('Failed to fetch test cases', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestCases();
  }, [suite, testCycleId, page, perPage, filters]);

  const handleFilters = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handlePageSizeChange = (e) => {
    const newPerPage = parseInt(e.target.value, 10);
    setPerPage(newPerPage);
    setPage(1);
  };

  return (
    <div className="mt-2" style ={{ minHeight: '85vh', maxHeight: '85vh'}}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="subtitle1">
          Test Suite: <strong>{suite.name}</strong>
        </Typography>

        <Button
          title="Back to Test Suites"
          onClick={handleBack}
          variant="outlined"
          startIcon={<ArrowBack />}>
          Back to Test Suites
        </Button>
      </Box>
      <Row>
          <Form.Group controlId="technologyLayer" className="mb-0" style ={{ width: '300px' }}>
            <Form.Label>Technology Layer</Form.Label>
            <Form.Select
              name="technologyLayer"
              value={filters.technologyLayer}
              onChange={handleFilters}>
              <option value="All">All</option>
              {technologyLayerOptions.map(({ id, name }) => (
                <option key={id} value={name}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group controlId="module" className="mb-0" style ={{ width: '300px' }}>
            <Form.Label>Module</Form.Label>
            <Form.Select
              name="module"
              value={filters.module}
              onChange={handleFilters}>
              <option value="All">All</option>
              {filteredModuleOptions.map(({ id, name }) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="labels" className="mb-0" style ={{ width: '300px' }}>
            <Form.Label>Labels</Form.Label>
            <MultiSelectDropdown
              options={filteredLabelOptions}
              selectedValues={filters.labels}
              onChange={(selected) => {
                setFilters((prev) => ({
                  ...prev,
                  labels: selected,
                }));
                setPage(1);
              }}
              maxSelections={filteredLabelOptions.length}
              placeholder="Select Labels"
              name='labels'
              sx={{ width: '100%' }}
            />
          </Form.Group>
      </Row>
      <TableComponent
          data={data}
          headerTabs={testCasestableHeader}
          order={order}
          setOrder={setOrder}
          defaultSort="created_at"
          isLoading={loading}
          striped
          showCheckbox
          selected={selectedTestCases}
          setSelected={setSelectedTestCases}
          isRowDisabled={(row) => row.is_linked_to_cycle}
          tablekey="test cases"
          page={page}
          perPage={perPage}
          totalCount={totalCount}
          showPages={true}
          showCount={true}
          handlePageChange={handlePageChange}
          setPerPage={handlePageSizeChange}
          showRowCount={true}
        />
    </div>
  );
};

export default SelectTestCasesFromSuiteModal;
